import { render, staticRenderFns } from "./Authorizations.vue?vue&type=template&id=eab11730&scoped=true"
import script from "./Authorizations.vue?vue&type=script&lang=js"
export * from "./Authorizations.vue?vue&type=script&lang=js"
import style0 from "./Authorizations.vue?vue&type=style&index=0&id=eab11730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eab11730",
  null
  
)

export default component.exports